export default __webpack_public_path__ + "static/media/20230505_WellWeb_Home x Dhanar X Komune Last 150-10.27ff69f1.png";